"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StyledIconButton = exports.EmptyContainer = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
const EmptyContainer = exports.EmptyContainer = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        position: 'relative',
        alignItems: 'center',
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[200],
        display: 'flex',
        height: 160,
        justifyContent: 'center',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden'
    };
});
const StyledIconButton = exports.StyledIconButton = (0, _mui.styled)(_components.IconButton)((param)=>{
    let { theme } = param;
    return {
        position: 'absolute',
        right: theme.spacing(2),
        bottom: theme.spacing(2)
    };
});
